import { LightMode, Spinner } from "@chakra-ui/react";
import { useTranslate } from "@tolgee/react";
import { validateEmail } from "src/common";
import { useSafeSetState } from "src/common/hooks";
import CompassInput from "src/components/compass/Input";
import PrimaryColorButton from "src/components/PrimaryColorButton";
import { impersonateUser } from "src/services/impersonation";

const initialState = {
  email: "",
  loading: false,
  error: false,
};

const ImpersonationForm = ({
  isImpersonating,
  initializeImpersonation,
  clearImpersonation,
}) => {
  const { t } = useTranslate();

  const [{ email, error, loading }, safeSetState] =
    useSafeSetState(initialState);

  const handleLogin = () => {
    if (loading) return;
    safeSetState({ loading: true, error: false });
    impersonateUser(email)
      .then((r: any) => {
        safeSetState({
          loading: false,
          email,
        });
        initializeImpersonation({ id: r.id, token: r.token, email });
      })
      .catch(() => safeSetState({ loading: false, error: true }));
  };

  const handleLogout = () => {
    clearImpersonation();
  };

  if (isImpersonating) {
    return (
      <>
        <p>
          {t({
            key: "profile.impersonate.description",
            params: { isImpersonating },
            defaultValue: `Impersonating User: ${isImpersonating}`,
          })}
        </p>
        <LightMode>
          <PrimaryColorButton onClick={handleLogout} colorModeOverride="light">
            {t({
              key: "profile.impersonate.button.exit",
              defaultValue: "Exit",
            })}
          </PrimaryColorButton>
        </LightMode>
      </>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleLogin();
      }}
    >
      <LightMode>
        <CompassInput
          placeholder={t({
            key: "profile.impersonate.placeholder",
            defaultValue: "Impersonate User?",
          })}
          value={email}
          onChange={(e) => safeSetState({ email: e.target.value })}
          disabled={loading}
          size={"sm"}
        />
        {error && (
          <p className="impersonate-error">
            {t({
              key: "profile.impersonate.disabled",
              defaultValue: "Impersonation is disabled for this account.",
            })}
          </p>
        )}
        <PrimaryColorButton
          className="impersonate-button"
          aria-busy={loading}
          disabled={!validateEmail(email)}
          type="submit"
          mt={2}
          colorModeOverride="light"
        >
          {loading ? (
            <Spinner size="sm" />
          ) : (
            t({
              key: "profile.impersonate.button.login",
              defaultValue: "Log In",
            })
          )}
        </PrimaryColorButton>
      </LightMode>
    </form>
  );
};

export default ImpersonationForm;
